import { useQuery } from "@tanstack/react-query";
import type { Kpi } from "../../types";
import { kpiService } from "../../services/kpiService";

export const useKpi = (kpiId?: string) => {
  return useQuery<Kpi>({
    enabled: Boolean(kpiId),
    queryKey: ["kpi", kpiId],
    retry: false,
    queryFn: async () => {
      const kpi = await kpiService.get(kpiId!);
      if (!kpi) {
        throw new Error(`KPI with id "${kpiId}" not found`);
      }
      return kpi;
    },
  });
};
